<template>
    <div>
       卡卷模组
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
